import React, { useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './ConsultationSection.css';

const ConsultationSection = ({
  title = "Register Now For Online Quran Courses",
  subtitle = "Kindly fill out the form below to request a free trial. We are available 24/7 for support."
}) => {
  useEffect(() => {
    // Load Calendly widget script dynamically
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section
      className="consultation-section"
      id="consultation"
      style={{
        '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')`
      }}
    >
      <div className="consultation-section__container">
        {/* Header Block */}
        <div className="consultation-section__header">
          <h2 className="consultation-section__title">
            {title}
          </h2>
          <div className="consultation-section__subtitle">
            {subtitle}
          </div>
        </div>

        {/* Content Columns */}
        <div className="consultation-section__grid">
          {/* Left Column: Calendly widget */}
          <div className="consultation-section__widget-container">
            <div
              className="calendly-inline-widget"
              data-url="https://calendly.com/alquranlesson/call-consultation"
              style={{ minWidth: '320px', height: '700px' }}
            />
          </div>

          {/* Right Column: Contact Info list */}
          <div className="consultation-section__info">
            <p className="consultation-section__info-title">CONTACT INFO</p>

            <ul className="consultation-section__list">
              <li className="consultation-section__item">
                <div className="consultation-section__icon-wrapper">
                  <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <a href="https://maps.google.com/?q=Mississauga,+Ontario,+L5K,+1W2" target="_blank" rel="noopener noreferrer" className="consultation-section__link">
                  Mississauga, Ontario, L5K, 1W2
                </a>
              </li>

              <li className="consultation-section__item">
                <div className="consultation-section__icon-wrapper">
                  <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <a href="https://maps.google.com/?q=1942+BROADWAY+ST+STE+314C,+80302,+BOULDER,+United+States" target="_blank" rel="noopener noreferrer" className="consultation-section__link">
                  1942 BROADWAY ST STE 314C, 80302, BOULDER, United States
                </a>
              </li>

              <li className="consultation-section__item">
                <div className="consultation-section__icon-wrapper">
                  <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <a href="tel:+16477385707" className="consultation-section__link">+1 647 738 5707 (Canada)</a>
              </li>

              <li className="consultation-section__item">
                <div className="consultation-section__icon-wrapper consultation-section__icon-wrapper--whatsapp">
                  <FaWhatsapp className="consultation-section__icon" />
                </div>
                <a href="https://wa.me/17164577657" target="_blank" rel="noopener noreferrer" className="consultation-section__link">716-457-7657</a>
              </li>

              <li className="consultation-section__item">
                <div className="consultation-section__icon-wrapper">
                  <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <a href="tel:+17164577657" className="consultation-section__link">+1 716 457 7657 (USA)</a>
              </li>

              <li className="consultation-section__item">
                <div className="consultation-section__icon-wrapper">
                  <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <a href="tel:+447441394281" className="consultation-section__link">+44 7441 394281 (UK)</a>
              </li>

              <li className="consultation-section__item">
                <div className="consultation-section__icon-wrapper">
                  <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <a href="mailto:info@alquranlesson.com" className="consultation-section__link">info@alquranlesson.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationSection;

